import styled from 'styled-components'

export const Container = styled.span`
  .tooltip {
    background: white;
    opacity: 1;
    color: #666666;
    font-weight: 300;
    border: 1px solid rgb(216, 216, 216);
    border-radius: 8px;
    padding: 16px;
    z-index: 99;

    .react-tooltip-arrow {
      border-width: 1px;
      border-style: solid;
      border-color: white rgb(216, 216, 216) rgb(216, 216, 216) white;
    }
  }
`
